import { render } from "./LivrosView.vue?vue&type=template&id=65b90360&scoped=true"
import script from "./LivrosView.vue?vue&type=script&lang=js"
export * from "./LivrosView.vue?vue&type=script&lang=js"

import "./LivrosView.vue?vue&type=style&index=0&id=65b90360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b90360"]])

export default __exports__